import React from 'react';
import Svg from '../shared/Svg';
import './TimeFormNotification.scss';

export const TimeFormNotification = () => {
  return (
    <div className='time-form-notification-container'>
      <Svg className='time-form-notification-image' data='/assets/warning.svg' fill='#514F4D'/>
      <div className='time-form-notification-details'>
        <p className='time-form-notification-text'>Add Time to save email & files.</p>
      </div>
    </div>
  );
};
